import { urlDiscussionForumGrading } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IBodyCreateDiscussionForumGrade,
  IBodyUpdateDiscussionForumGrade,
  IDiscussionForumGrade,
  IQueryGetDiscussionForumGrading,
} from '~/utils/interface/discussion';

export const discussionForumGradingApi = {
  getListDiscussionForumGrading(params: IQueryGetDiscussionForumGrading) {
    const url = `${urlDiscussionForumGrading.getList}`;
    return axiosClient.get<IBaseResponse<IListDataResponse<IDiscussionForumGrade[]>>>(url, { params });
  },

  createDiscussionForumGrading(body: IBodyCreateDiscussionForumGrade) {
    const url = `${urlDiscussionForumGrading.create}`;
    return axiosClient.post<IBaseResponse<IDiscussionForumGrade>>(url, body);
  },

  updateDiscussionForumGrading(id: string, body: IBodyUpdateDiscussionForumGrade) {
    const url = `${urlDiscussionForumGrading.update(id)}`;
    return axiosClient.put<IBaseResponse<IDiscussionForumGrade>>(url, body);
  },

  deleteDiscussionForumGrading(id: string) {
    const url = `${urlDiscussionForumGrading.deleteById(id)}`;
    return axiosClient.delete<IBaseResponse>(url);
  },
};
